// CRM theme — values mirror shared/tokens.css. The CSS is the source of truth;
// these constants exist only for the few places that need a JS string
// (e.g. SVG stroke colors that can't read CSS variables).

export const Z = {
  paper: '#FAF8F3',
  white: '#FAF8F3', // --color-white is the card surface, not #fff
  ink1000: '#0A0A0A',
  ink900: '#161616',
  ink700: '#2E2E2E',
  ink500: '#6B6B6B',
  ink300: '#B5B5B5',
  ink200: '#E2E0DB',
  ink100: '#EFEDE7',
  ink50: '#F5F3EE',
  accent: '#FFE600',
  accentSoft: '#FFF06B',
  accentDeep: '#E5CE00',
  clay: '#B7855B',
  moss: '#5C6B4F',
  stone: '#8E8B82',
  terracotta: '#B05A3C',
  success: '#2E7D4F',
  warning: '#C77B1F',
  danger: '#B23A2A',
} as const
